import React from 'react'
import "./History_tab_content.css"
import { Tab, Tabs } from 'react-bootstrap'
import All_bets_history from './all_bets_history/All_bets_history'
import All_Bets from './all_bets/All_Bets'

function History_tab_content() {
    return (
        <>
            <section className='History_tab_content'>
                <div className="row justify-content-center">
                    <div className="col-lg-7 col-md-10">
                        <div className="profile_tabs_and_content">
                            <div className="section_holder">
                                <div className="Inner_tabs_section">
                                    <Tabs
                                        defaultActiveKey="ALL_BETS_HISTORY"
                                        id="fill-tab-example"
                                        className="mb-3"
                                        fill
                                    >
                                        <Tab eventKey="ALL_BETS_HISTORY" title="ALL_BETS_HISTORY">
                                            <All_bets_history />
                                        </Tab>
                                        <Tab eventKey="ALL_BETS" title="ALL_BETS">
                                            <All_Bets />
                                        </Tab>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export default History_tab_content